import React from 'react';

import { CommonHash, PersonalStatementQuestion } from 'app/types';

import styles from '../PersonalStatementBuilder.module.scss';
import { LabelInputComponent } from '../PersonalStatementBuilder';

interface CompProps {
  setInputOption: (
    key: string,
    value: any,
    setStateFunction: (value: React.SetStateAction<CommonHash>) => void
  ) => void;
  schoolMotivationsQuestion?: PersonalStatementQuestion;
  schoolMotivations: CommonHash;
  setSchoolMotivations: React.Dispatch<React.SetStateAction<CommonHash>>;
  countryMotivationsQuestion?: PersonalStatementQuestion;
  countryMotivations: CommonHash;
  setCountryMotivations: React.Dispatch<React.SetStateAction<CommonHash>>;
  deleteBulletInputOption: (
    key: string,
    setStateFunction: (value: React.SetStateAction<CommonHash>) => void,
    stateToChange: CommonHash
  ) => void;
}

export const MotivationsStep = ({
  setInputOption,
  schoolMotivationsQuestion,
  schoolMotivations,
  setSchoolMotivations,
  countryMotivationsQuestion,
  countryMotivations,
  setCountryMotivations,
  deleteBulletInputOption,
}: CompProps): React.ReactElement => {
  return (
    <>
      <div className={styles.stepTitle} style={{ marginBottom: '8px' }}>
        Motivations
      </div>
      <div className={styles.stepSubtitle}>
        This section helps to demonstrate your interest in the university/programme.
      </div>
      {schoolMotivationsQuestion && (
        <>
          <div className={styles.statementQuestion} style={{ marginTop: '40px' }}>
            {schoolMotivationsQuestion?.title}&nbsp;
            {schoolMotivationsQuestion?.min_content &&
              `(at least ${schoolMotivationsQuestion.min_content} answers)`}
          </div>
          {schoolMotivationsQuestion?.subtitle && (
            <div className={styles.questionSubtitle}>{schoolMotivationsQuestion?.subtitle}</div>
          )}
          {Object.keys(schoolMotivations.content).map((key) => (
            <LabelInputComponent
              key={key}
              keyNumber={key}
              setInputFunction={setInputOption}
              setObjectFunction={setSchoolMotivations}
              inputValue={schoolMotivations.content[key]}
              placeholderText="Type in your answer"
              canBeDeleted={Object.keys(schoolMotivations.content).length > 3}
              deleteBulletInputOption={deleteBulletInputOption}
              stateToChange={schoolMotivations}
            />
          ))}
          <div
            className={styles.itemLabel}
            style={{ marginTop: '20px' }}
            onClick={() =>
              setInputOption(
                (Object.keys(schoolMotivations['content']).length + 1).toString(),
                '',
                setSchoolMotivations
              )
            }
          >
            +
          </div>
        </>
      )}
      {countryMotivationsQuestion && (
        <>
          <div className={styles.statementQuestion} style={{ marginTop: '100px' }}>
            {countryMotivationsQuestion?.title}&nbsp;
            {countryMotivationsQuestion?.min_content &&
              `(at least ${countryMotivationsQuestion.min_content} answers)`}
          </div>
          {countryMotivationsQuestion?.subtitle && (
            <div className={styles.questionSubtitle}>{countryMotivationsQuestion?.subtitle}</div>
          )}
          {Object.keys(countryMotivations.content).map((key) => (
            <LabelInputComponent
              key={key}
              keyNumber={key}
              setInputFunction={setInputOption}
              setObjectFunction={setCountryMotivations}
              inputValue={countryMotivations.content[key]}
              placeholderText="Type in your answer"
              canBeDeleted={Object.keys(countryMotivations.content).length > 3}
              deleteBulletInputOption={deleteBulletInputOption}
              stateToChange={countryMotivations}
            />
          ))}
          <div
            className={styles.itemLabel}
            style={{ marginTop: '20px' }}
            onClick={() =>
              setInputOption(
                (Object.keys(countryMotivations['content']).length + 1).toString(),
                '',
                setCountryMotivations
              )
            }
          >
            +
          </div>
        </>
      )}
    </>
  );
};
